import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { AuthenticationService } from 'app/auth/service';
import { DeviceFingerprintService } from 'app/auth/service/device-fingerprint.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private _authenticationService: AuthenticationService,
    private _deviceFingerprintService: DeviceFingerprintService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    var currentUser = this._authenticationService.currentUserValue;
    
    const isLoggedIn = currentUser && currentUser.token;
    
    if (isLoggedIn && (request && request['url'] && !request['url'].includes('cloudfunctions'))) {
      const deviceId = this._deviceFingerprintService.getStoredDeviceId();
      
      const headers = {
        Authorization: `Bearer ${currentUser.token}`,
        Client: currentUser.tenantId,
        CustomerId: currentUser.customerId
      };

      // Add device ID if available
      if (deviceId) {
        (headers as any)['X-Device-ID'] = deviceId;
      }

      request = request.clone({
        setHeaders: headers
      });
    }

    return next.handle(request);
  }
}
